export default __webpack_public_path__ + "static/media/ic-arrowdownup.d0dad86c.svg";